import './style.scss'

import React, { PureComponent } from 'react'
import Modal from 'components/UI/Modal'
import Button from 'components/UI/Button'
import ButtonRow from 'components/UI/ButtonRow'
import ButtonColumn from 'components/UI/ButtonColumn'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class SubscriptionStoppedModal extends PureComponent {
    getSubscriptionProductText = () => {
        const { subscriptions, products, product, t } = this.props
        let subscriptionProductText = ''
        let actionText = t('subscriptionAddToSubscriptionButtonConfirmAddProduct')
        if (subscriptions) {
            if (subscriptions.length === 1) {
                const subscriptionProduct = products.find(
                    (p) => p.id === subscriptions[0].id.toString()
                )
                subscriptionProductText = t('subscriptionAddToSubscriptionButtonExistingProducts', {
                    subscriptionProduct: subscriptionProduct.title,
                })
                actionText = t('subscriptionAddToSubscriptionButtonConfirmRemoveProduct', {
                    subscriptionProduct: subscriptionProduct.title,
                    product: product.title,
                })
            } else if (subscriptions.length > 1) {
                subscriptionProductText = t(
                    'subscriptionAddToSubscriptionButtonExistingProductsMultiple',
                    {
                        subscriptionProductCount: subscriptions.length,
                    }
                )
                actionText = t('subscriptionAddToSubscriptionButtonConfirmRemoveProductMultiple', {
                    product: product.title,
                })
            }
        }
        return { subscriptionProductText, actionText }
    }

    handleOnClose = () => {
        const { onClose } = this.props
        if (onClose) onClose()
    }

    handleStartSubscriptionAndAddProduct = (product, replace) => {
        const { startSubscriptionAndAddProduct } = this.props
        if (startSubscriptionAndAddProduct) startSubscriptionAndAddProduct(product, replace)
    }
    renderCancelButton() {
        const { t } = this.props
        return (
            <Button
                variant="secondary"
                onClick={this.handleOnClose}
                className="subscription-stopped-modal__confirm-button"
            >
                {t('subscriptionAddToSubscriptionButtonCancel')}
            </Button>
        )
    }

    renderConfirmButtons = () => {
        const { t, subscriptions, product } = this.props
        if (subscriptions && subscriptions.length > 0) {
            return (
                <React.Fragment>
                    <Button
                        className="subscription-stopped-modal__confirm-button"
                        variant="primary"
                        onClick={() => this.handleStartSubscriptionAndAddProduct(product)}
                    >
                        {t('subscriptionAddToSubscriptionButtonNoJustAdd')}
                    </Button>
                    <Button
                        className="subscription-stopped-modal__confirm-button"
                        variant="primary"
                        onClick={() => this.handleStartSubscriptionAndAddProduct(product, true)}
                    >
                        {t('subscriptionAddToSubscriptionButtonYesRemoveAndAdd')}
                    </Button>
                </React.Fragment>
            )
        } else if (!subscriptions || subscriptions.length === 0) {
            return (
                <Button
                    variant="primary"
                    className="subscription-stopped-modal__confirm-button"
                    onClick={() => this.handleStartSubscriptionAndAddProduct(product)}
                >
                    {t('subscriptionAddToSubscriptionButtonOK')}
                </Button>
            )
        }
    }

    render() {
        const { subscriptions, isMobile, t } = this.props
        let { subscriptionProductText, actionText } = this.getSubscriptionProductText()

        return (
            <Modal show={true} onClose={this.handleOnClose}>
                <div className="subscription-stopped-modal__title">
                    {t('subscriptionAddToSubscriptionButtonConfirm')}
                </div>
                {subscriptions && subscriptions.length > 0 && (
                    <div className="subscription-stopped-modal__products">
                        {subscriptionProductText}
                    </div>
                )}
                <div className="subscription-stopped-modal__actions">{actionText}</div>
                {!isMobile && (
                    <ButtonRow className="subscription-stopped-modal__confirm-buttons">
                        {this.renderCancelButton()}
                        {this.renderConfirmButtons()}
                    </ButtonRow>
                )}
                {isMobile && (
                    <ButtonColumn>
                        {this.renderConfirmButtons()}
                        {this.renderCancelButton()}
                    </ButtonColumn>
                )}
            </Modal>
        )
    }
}

SubscriptionStoppedModal.propTypes = {
    isMobile: PropTypes.bool,
    product: PropTypes.object.isRequired,
    subscriptions: PropTypes.array,
    products: PropTypes.array,
    onClose: PropTypes.func,
    startSubscriptionAndAddProduct: PropTypes.func,
    t: PropTypes.func,
}

export default withTranslation()(SubscriptionStoppedModal)
